/**
 * New Expedient
 * Expedient for Student Account
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The TransferAcademicRecord model module.
 * @module model/TransferAcademicRecord
 * @version 1.0
 */
class TransferAcademicRecord {
    /**
     * Constructs a new <code>TransferAcademicRecord</code>.
     * @alias module:model/TransferAcademicRecord
     */
    constructor() { 
        
        TransferAcademicRecord.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>TransferAcademicRecord</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/TransferAcademicRecord} obj Optional instance to populate.
     * @return {module:model/TransferAcademicRecord} The populated <code>TransferAcademicRecord</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TransferAcademicRecord();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('student_id')) {
                obj['student_id'] = ApiClient.convertToType(data['student_id'], 'Number');
            }
            if (data.hasOwnProperty('academic_program_id')) {
                obj['academic_program_id'] = ApiClient.convertToType(data['academic_program_id'], 'Number');
            }
            if (data.hasOwnProperty('academic_program_translation')) {
                obj['academic_program_translation'] = ApiClient.convertToType(data['academic_program_translation'], 'String');
            }
            if (data.hasOwnProperty('status_id')) {
                obj['status_id'] = ApiClient.convertToType(data['status_id'], 'Number');
            }
            if (data.hasOwnProperty('comments')) {
                obj['comments'] = ApiClient.convertToType(data['comments'], 'String');
            }
            if (data.hasOwnProperty('created_by')) {
                obj['created_by'] = ApiClient.convertToType(data['created_by'], 'Number');
            }
            if (data.hasOwnProperty('updated_by')) {
                obj['updated_by'] = ApiClient.convertToType(data['updated_by'], 'Number');
            }
            if (data.hasOwnProperty('is_validated')) {
                obj['is_validated'] = ApiClient.convertToType(data['is_validated'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
TransferAcademicRecord.prototype['id'] = undefined;

/**
 * @member {Number} student_id
 */
TransferAcademicRecord.prototype['student_id'] = undefined;

/**
 * @member {Number} academic_program_id
 */
TransferAcademicRecord.prototype['academic_program_id'] = undefined;

/**
 * @member {String} academic_program_translation
 */
TransferAcademicRecord.prototype['academic_program_translation'] = undefined;

/**
 * @member {Number} status_id
 */
TransferAcademicRecord.prototype['status_id'] = undefined;

/**
 * @member {String} comments
 */
TransferAcademicRecord.prototype['comments'] = undefined;

/**
 * @member {Number} created_by
 */
TransferAcademicRecord.prototype['created_by'] = undefined;

/**
 * @member {Number} updated_by
 */
TransferAcademicRecord.prototype['updated_by'] = undefined;

/**
 * @member {Boolean} is_validated
 */
TransferAcademicRecord.prototype['is_validated'] = undefined;






export default TransferAcademicRecord;

